import { render, staticRenderFns } from "./AdCellName.vue?vue&type=template&id=3018118a&scoped=true"
import script from "./AdCellName.vue?vue&type=script&lang=js"
export * from "./AdCellName.vue?vue&type=script&lang=js"
import style0 from "./AdCellName.vue?vue&type=style&index=0&id=3018118a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3018118a",
  null
  
)

export default component.exports